<template>
  <v-footer app class="white--text" color="blue-grey">
    <span>{{ $t('amazeing') }}</span>
    <v-spacer/>
  

    <span> <a href="https://www.uni-saarland.de/impressum.html" style="color: white; text-decoration: none;"> &copy; {{ $t('prog2_pk') }}</a></span>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>
